import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '/#about'
  }, {
    name: 'Services',
    href: '/#services'
  }, {
    name: 'Pricing',
    href: '/#pricing'
  }, {
    name: 'Gallery',
    href: '/#gallery'
  }, {
    name: 'Contact',
    href: '/#contact'
  }];
  // Determine if we are on a dark background page (like home hero) or light background (like pricing page)
  // For simplicity, we'll keep the navbar dark when scrolled, and transparent when at top.
  // On the pricing page, the hero is also dark, so the same logic works perfectly.
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${isScrolled ? 'bg-charcoal/90 backdrop-blur-md py-4' : 'bg-transparent py-8'}`} data-id="element-118">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-119">
        <Link to="/" className="block" data-id="element-120">
          <img src="https://code-11.hr/wp-content/uploads/2023/03/logo-i-tekst-1.png" alt="Code 11" className="h-20 md:h-24 w-auto" data-id="element-121" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-122">
          {navLinks.map(link => <Link key={link.name} to={link.href} className="text-xs font-sans text-white/50 hover:text-white uppercase tracking-[0.15em] transition-colors duration-300" data-id="element-123">
              {link.name}
            </Link>)}
          <Link to="/weddings-pricing" className="ml-2 px-4 py-2 bg-copper text-charcoal hover:bg-copper/90 transition-colors duration-300 font-sans text-[10px] uppercase tracking-[0.15em]" data-id="element-124">
            View Prices
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white/70 hover:text-white transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-125">
          {mobileMenuOpen ? <X size={24} strokeWidth={1.5} data-id="element-126" /> : <Menu size={24} strokeWidth={1.5} data-id="element-127" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-charcoal/95 backdrop-blur-md border-t border-white/5" data-id="element-128">
          <div className="flex flex-col px-6 py-8 space-y-6" data-id="element-129">
            {navLinks.map(link => <Link key={link.name} to={link.href} className="text-xs font-sans text-white/50 hover:text-white uppercase tracking-[0.15em] transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-130">
                {link.name}
              </Link>)}
            <Link to="/weddings-pricing" onClick={() => setMobileMenuOpen(false)} className="self-start px-4 py-2 bg-copper text-charcoal font-sans text-[10px] uppercase tracking-[0.15em]" data-id="element-131">
              View Prices
            </Link>
          </div>
        </div>}
    </nav>;
}